angular.module('impactx.stockwithdrawal').controller('UnbookStockWithdrawalCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'ToastService',
    'TranslationService',
    'themeFactory',
    UnbookStockWithdrawalCtrl
]);

function UnbookStockWithdrawalCtrl($scope, dataGen, $mdDialog, ToastService, TranslationService, themeFactory) {
    var self = this;
    $scope.theme = themeFactory.getTheme();
    $scope.data = self.dniInfoData;
    $scope.trns = self.trns;

    self.abort = function() {
        $mdDialog.cancel();
    };
    self.unbook = function() {
        dataGen.postAsForm($scope, {ids: self.dniInfoIds}, '/stockwithdrawal/unbook').then(function () {
            $mdDialog.hide();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        })
    };
}